import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    Api for Media
    @author  CKR013
    @date    2020.5.18
    @version 0.1    
 ******************************************/
class searchApi {
    static getMedias(idx, category, searchKey) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/media/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?category=${category}&index=${idx}`;
        urlMe += searchKey.length === 0 ? '' : `&search=${searchKey}`;
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Medias error==", error);
            return error;
        });
    }

    static getSiblings(bs, bsId) {
        var urlMe = `${apiConstant.API_URL}/media/imagesByBs?bs=${bs}&bsId=${bsId}`;
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Medias error==", error);
            return error;
        });
    }

    static paginate(page, bs, category, searchKey) {
        var lang_key = localStorage.getItem('language');
        var urlMe = `${apiConstant.API_URL}/search/paginate/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?bs=${bs}&category=${category}&page=${page}`;
        urlMe += searchKey && searchKey.length === 0 ? '' : `&search=${searchKey}`;
        return axios({
            url : urlMe,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {             
            return response;
        })
        .catch(function (error) {
            console.log("Get Medias error==", error);
            return error;
        });
    }

    // static getSideMedias(business, targetBusiness) {
    //     var lang_key = localStorage.getItem('language');
    //     var urlMe = `${apiConstant.API_URL}/media/others/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}?b=${targetBusiness}&tb=${targetId}`;        
    //     return axios({
    //         url : urlMe,
    //         method: 'GET',
    //         headers: {
    //             'accept': 'application/json'
    //         }
    //     })
    //     .then(function (response) { 
    //         return response;
    //     })
    //     .catch(function (error) {
    //         console.log("Get Medias error==", error);
    //         return error;
    //     });
    // }

    // static getMedia(category, id) {
    //     var lang_key = localStorage.getItem('language');
    //     var urlMe = `${apiConstant.API_URL}${business}/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/${id}`;
    //     return axios({
    //         url : urlMe,
    //         method: 'GET',
    //         headers: {
    //             'accept': 'application/json'
    //         }
    //     })
    //     .then(function (response) {              
    //         return response;
    //     })
    //     .catch(function (error) {
    //         console.log("Get Medias error==", error);
    //         return error;
    //     });
    // }

    static getMediaTitle(business, id) {
        var lang_key = localStorage.getItem('language');
        return axios({
            url : `${apiConstant.API_URL}${business}/title/${(lang_key === undefined || lang_key === null)? 'en' : lang_key}/${id}`,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Medias error==", error);
            return error;
        });
    }

    static getCategories() {        
        return axios({
            url : `${apiConstant.API_URL}/media/category`,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {              
            return response;
        })
        .catch(function (error) {
            console.log("Get Medias error==", error);
            return error;
        });
    }
}

export default searchApi;